// Client-side mirror of apps/api/src/lib/domain.ts `normalizeDomain`. Used only
// to preview what the scanner WILL actually scan ("we'll scan: example.com")
// so users who paste a URL or a www host aren't surprised. The Worker re-runs
// the authoritative normalization on every scan — keep these two in sync.

const DOMAIN_RE = /^(?=.{1,253}$)([a-z0-9](-?[a-z0-9])*\.)+[a-z]{2,63}$/i;

export function normalizeDomain(input: string): string | null {
  if (!input) return null;
  let s = input.trim().toLowerCase();
  s = s.replace(/^https?:\/\//, '');     // strip protocol
  s = s.split('/')[0];                    // strip path/query
  s = s.split('@').pop()!;                // strip user:pass@
  s = s.split(':')[0];                    // strip port
  s = s.replace(/\.+$/, '');              // strip trailing dot
  try {
    const u = new URL('http://' + s);
    s = u.hostname;
  } catch {
    return null;
  }
  // Reduce a leading www. to the apex (org records live on the apex). Only when
  // the remainder is still a valid domain, and only `www` — not other subdomains.
  if (s.startsWith('www.')) {
    const apex = s.slice(4);
    if (DOMAIN_RE.test(apex)) s = apex;
  }
  if (!DOMAIN_RE.test(s)) return null;
  return s;
}
